/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ width: NonNullable<unknown>, height: NonNullable<unknown> }} Crosspostingframinghint2Inputs */

const en_crosspostingframinghint2 = /** @type {(inputs: Crosspostingframinghint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drag the frame to choose the visible section - the rest is cropped. Published at ${i?.width} × ${i?.height} px.`)
};

const de_crosspostingframinghint2 = /** @type {(inputs: Crosspostingframinghint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ziehe den Rahmen, um den sichtbaren Ausschnitt zu wählen – der Rest wird abgeschnitten. Veröffentlicht mit ${i?.width} × ${i?.height} px.`)
};

/**
* | output |
* | --- |
* | "Drag the frame to choose the visible section - the rest is cropped. Published at {width} × {height} px." |
*
* @param {Crosspostingframinghint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingframinghint2 = /** @type {((inputs: Crosspostingframinghint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingframinghint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingframinghint2(inputs)
	return de_crosspostingframinghint2(inputs)
});
export { crosspostingframinghint2 as "crosspostingFramingHint" }